(function () {
  
  // Model: Handles API calls to backend
  class DiscountModel {
    constructor() {
      this.marketplace = 'india';
    }
    async applyDiscountCode(cartId, code) {
      let body = {
        "cartId": `gid://shopify/Cart/${cartId}`,
        "discountCodes": code
      };

      let applyContent = { error: true };

      try {
        return await (await fetch(`https://storefront-shopify.slimcase.vn/${this.marketplace}/api/2025-02/shopify/cart/discount.json`, {
          method: 'POST',
          headers: {
            Accept: '*/*',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        })).json();

      } catch (error) {
        return applyContent;
      }

    }
    async getCart() {
      return await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    }
    async cancelDiscountCode() {
      return await this.updateCartEndpoint({ discount: "" });
    }
    async updateCart(items,discount_code = "") {
      return await this.updateCartEndpoint({ updates: items, discount: discount_code });
    }
    async updateCartEndpoint(data){
      return await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
    async discountAvailable(code) {
      if (!code || code.length == 0) return { available: false,message:"Invalid discount code." };
      let body = {
        "discount_code": code
      };
      try {
        let response = await (await fetch(`https://storefront-shopify.slimcase.vn/${this.marketplace}/api/2025-09/shopify/discount/available.json`, {
          method: 'POST',
          headers: {
            Accept: '*/*',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        })).json();

        return response
      } catch (error) {
        console.error('Error checking discount availability:', error);
      }
      return { available:false, message:"Server overload. Please try again later."};
    }
  }

  // Controller: Business logic
  class DiscountController {
    constructor(model, view) {
      this.model = model;
      this.view = view; // view is now ApplyDiscountTag instance
      this.discountCode = '';
      this.list_gifts_in_cart = [];
    }
    async removeDiscountCode(code) {
      let cart = await this.model.getCart();
      if (!cart || !cart.token) return;
      // open popup confirm remove discount
      this.view.showConfirmRemoveDiscount({
        cart_id: cart.token,
        discount_code: code
      });
    }
    async executeCancel() {
      let response = await this.model.cancelDiscountCode();
      this.view.stopLoadingBtn();
      this.view.refresh();
      this.view.showSuccessMessage();

    }
    async execute(code) {
      
      let response = await this.model.discountAvailable(code);
      if (response.available == false) {
        this.view.clearInput();
        this.view.showFailMessage(response.message || "This code is not valid");
        return;
      }

      let cart = await this.model.getCart();
      let items = this.extractItems(cart);
      if (!items || Object.keys(items).length === 0) return;

      let list_gifts = this.getListGiftsAvailable();
      let gifts_in_cart = this.findGiftsInCart(items, list_gifts);

      if (!list_gifts || !gifts_in_cart.length) {
        await this.updateDiscountCode(cart.token, code);
        return;
      }

      this.view.showConfirmRemoveGift({
        cart_id: cart.token,
        discount_code: code,
        gifts: gifts_in_cart,
        items: items
      });
    }
    handleDiscountNotes(data) {
      this.view.hideAllNote();
      if (data.errors || data.cartDiscountCodesUpdate?.cart?.discountCodes[0]?.applicable == false) {
        this.view.showFailMessage();
        return;
      }
      if(data.cartDiscountCodesUpdate?.cart?.discountCodes && data.cartDiscountCodesUpdate.cart.discountCodes[0]?.applicable == true){
        this.view.showSuccessMessage();
        return
      }
    }
    fetchItemCountInCart() {
      return this.model.getCart().then(cart => {
        return cart.item_count;
      });
    }
    getItemCountInCart() {
      let item_count = this.model.getCart().then(cart => {
        return cart.item_count;
      });
      return item_count ?? 0;
    }
    removeGiftFromCart(line_items_old, gifts_old) {
      for (const [key, value] of Object.entries(line_items_old)) {
        if (gifts_old.includes(parseInt(key))) {
          line_items_old[key] = 0
        }
      }
      return line_items_old;
    }
    getListGiftsAvailable() {
      var list_gifts = window.list_gifts || []
      if (list_gifts.length == 0) {
        // call api to get list gift
        return []
      }
      return list_gifts
    }
    findGiftsInCart(items, list_gifts) {
      var gifts_in_cart = []
      // items is object {variant_id: quantity}
      // list_gifts is object {gift_variant_id: [eligible_variant_ids]}
      // extract keys of items
      var item_keys = Object.keys(items).map(id => parseInt(id));
      
      // loop through item_keys and check if it is in any of the values of list_gifts
      item_keys.forEach(function (item_id) {
        if(item_id in list_gifts) {
          gifts_in_cart.push(item_id);
        }
      })
      return gifts_in_cart;
    }
    extractItems(cart_data) {
      var data = {}
      var line_items = cart_data.items
      if (line_items.length == 0) return;
      line_items.forEach(function (item) {
        let variant_id = item.variant_id
        let quantity = item.quantity
        data[variant_id] = quantity
      })
      return data;
    }
    async updateBadgeCountCart() {
      let number = await this.getItemCountInCart()
      this.view.updateBadgeCountCart(number);

    }
    async updateDiscountCode(cart_id, discount_code,gifts=[],items={}) {
      // TODO : upgrade solution use `http://{shop}.myshopify.com/cart/{variant_id}:{quantity},{variant_id2}:{quantity2}?discount={discount_code}`
      let response = null;
      if (gifts.length) {
        // remove gift from cart
        let updates = this.removeGiftFromCart(items, gifts);
        response = await this.model.updateCart(updates,discount_code);
      }else{
        response = await this.model.applyDiscountCode(cart_id, discount_code);
      }

      this.handleDiscountNotes(response);
      this.view.refresh();

    }
  }

  // Custom tag definition
  class ApplyDiscountTag extends HTMLElement {
    constructor() {
      super();
      this.model = new DiscountModel();
      this.controller = new DiscountController(this.model, this); // pass self as view
      this.addEventListener("discount:apply:stoploading", this.stopLoadingBtn.bind(this));
      this.addEventListener("discount:execute", this._handleDiscountAction.bind(this));
      this.addEventListener("discount:execute:cancel", this._handleDiscountActionCancel.bind(this));
      this.addEventListener("discount:hide",this._hide.bind(this));
      this.addEventListener("discount:show",this._show.bind(this));
      this.addEventListener("click", this._handleClick.bind(this));
      this.addEventListener("discount:remove", this._handleDiscountRemove.bind(this));
    }
    // --- Former DiscountView methods ---
    async refresh() {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      await this.controller.updateBadgeCountCart();
    }
    async _handleDiscountActionCancel(event) {
      this.openPillLoader()
      this.controller.executeCancel();

    }
    async _handleDiscountRemove(event) {
      const { discount_code } = event.detail;
      if (!discount_code) return;
      this.loadingBtn(true);
      this.controller.removeDiscountCode(discount_code);
    }
    updateBadgeCountCart(number) {
      document.querySelectorAll("cart-count").forEach(function(el) {
        el.itemCount = number;
      });
    }
    clearInput() {
      this.querySelector('#discount-code').value = '';
      this.loadingBtn(false);
    }
    loadingBtn(mode) {
      var block_content_add = this.querySelector(".block_content_add")
      var text_apply = block_content_add.querySelector(".text--apply--discount")
      var spinner = block_content_add.querySelector(".loading")
      var btn = block_content_add.querySelector(".apply-discount")
      if (mode) {
        text_apply.classList.add("hide")
        spinner.classList.remove("hide")
        btn.setAttribute("disabled", "")
        return;
      }
      text_apply.classList.remove("hide")
      spinner.classList.add("hide")
      btn.removeAttribute('disabled');
    }
    _show(){
      this.style.display = "block";
      this.classList.remove("hide");
    }
    _hide(){
      this.style.display = "none";
      this.classList.add("hide");
    }
    openPillLoader() {
      var pill_loader = document.querySelectorAll("pill-loader");
      if (!pill_loader) return;
      // pill_loader.setAttribute("aria-busy", "true");
      pill_loader.forEach(function(loader) {
        loader.setAttribute("aria-busy", "true");
      });
 
    }
    hideAllNote() {
      document.querySelector("discount-note").dispatchEvent(new CustomEvent("discount:note:hide"));
    }
    showConfirmRemoveGift(data) {
      document.querySelector('popup-remove-gift').dispatchEvent(new CustomEvent("popup:show", { detail: data }));
      this._hide();
    }
    showConfirmRemoveDiscount(data) {
      document.querySelector('popup-remove-discount').dispatchEvent(new CustomEvent("popup:show", { detail: data }));
      this._hide();
    }
    showFailMessage(message) {
      document.querySelector("discount-note").dispatchEvent(new CustomEvent("discount:note:fail", { detail: { message } }));
    }
    showSuccessMessage(message = null) {
      document.querySelector("discount-note").dispatchEvent(new CustomEvent("discount:note:success", { detail: { message } }));
    }
    // --- End DiscountView methods ---
    async _handleDiscountAction(event) {
      const { cart_id, discount_code, gifts, items } = event.detail;
      if (!cart_id || !discount_code || !gifts.length){
        this.stopLoadingBtn();
        return;
      };

      this.openPillLoader()

      this.controller.updateDiscountCode(cart_id, discount_code, gifts, items);
    }
    _handleClick(event) {
      if (event.target && event.target.classList.contains('text--apply--discount')) {
        this.hideAllNote();
        const code = this.querySelector('#discount-code').value.trim();
        if (!code) {
          return;
        }
        this.loadingBtn(true);
        this.controller.execute(code);
      }
    }
    stopLoadingBtn() {
      this.loadingBtn(false)
      this._show();
    }
  }
  if (!window.customElements.get("apply-discount")) {
    window.customElements.define("apply-discount", ApplyDiscountTag);
  }

  var TagCodeDiscount = class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", this._handleClick.bind(this));
    }
    getDiscountCode(target) {

      const isTagSVG = target.tagName === 'svg' || target.tagName === 'path';
      if (isTagSVG) {
        const element = target.closest('div');
        return element.getAttribute('data-discount-id');
      }
      const isTargetClassDiv = target.classList.contains('discount-tag');
      if (isTargetClassDiv) {
        return target.getAttribute('data-discount-id');
      }
      return '';
    }
    _handleClick(event) {
      // If click is on the close element (or inside it), handle removal
      const target = event.target;
      if (!target) return;

      const discount_code = this.getDiscountCode(target);
      if (!discount_code) return;

      const applyEl = document.querySelector('apply-discount');
      if (!applyEl) return;
      applyEl.dispatchEvent(new CustomEvent('discount:remove', { detail: { discount_code } }));

    }
    hide(){
      this.style.display = "none";
    }
    show(){
      this.style.display = "block";
    }
  }
  if (!window.customElements.get("tag-code-discount")) {
    window.customElements.define("tag-code-discount", TagCodeDiscount);
  }
  var DiscountNote = class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("discount:note:fail", this._showFailNote.bind(this));
        this.addEventListener("discount:note:success", this._showSuccessNote.bind(this));
        this.addEventListener("discount:note:hide", this.hide.bind(this));
        this.addEventListener("click", this._handleClick.bind(this));
        this.hide();
      }
      _handleClick(event) {
        if (event.target && event.target.classList.contains('icon-close')) {
          this.hide();
        }
      }
      _showFailNote(event) {
        this._showNote(event?.detail?.message || "This code is not valid", false);
      }
      _showSuccessNote(event) {
        this._showNote(event?.detail?.message || "Discount applied successfully", true);
      }
      _showNote(message, isSuccess) {
        this.setNoticeText(message);
        this.show();
        this._changeState(isSuccess);
      }
      setNoticeText(message) {
        this.querySelector(".notice__text").innerHTML = message;
      }
      _changeState(isSuccess) {
        const class_status = `note--${isSuccess ? "success" : "fail"}`;
        this._removeState();
        this.classList.add(class_status);
      }
      _removeState(){
        this.classList.remove("note--success","note--fail","note--init");
      }
      _getState() {
  
        if (!this.classList) return 'none';
        if (this.classList.contains("note--success")) return "success";
        if (this.classList.contains("note--fail")) return "fail";
        if (this.classList.contains("note--init")) return "init";
        // If none of the above classes are present, treat as 'none'
        return "none";
      }
      show() {
        this.style.display = "block";
      }
      hide() {
        this.style.display = "none";
      }
    }
    if (!window.customElements.get("discount-note")) {
      window.customElements.define("discount-note", DiscountNote);
    }
  var PopupRemoveGift = class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("popup:show", this._showPopup.bind(this));
      this.addEventListener("popup:hide", this._hidePopup.bind(this));
      this.addEventListener("click", this._handleClick.bind(this));
      this.init();
    }
    init() {
      this.style.display = "none";
    }
    _showPopup(event) {
      const { cart_id, discount_code, gifts, items } = event.detail;
      if (!cart_id || !discount_code || !gifts.length) return;
      this.cart_id = cart_id;
      this.discount_code = discount_code;
      this.gifts = gifts;
      this.items = items;
      this.style.display = "block";
    }
    _handleClick(event) {

      if( event.target && event.target.classList.contains('confirm-remove-gift')) {
        this._confirmRemove();
        this._hidePopup();
        return;
      }
      this._cancelRemove();
      
    }
    _hidePopup() {
      this.style.display = "none";
      this.cart_id = null;
      this.discount_code = null;
      this.gifts = [];
      this.items = null;

      document.querySelector("apply-discount").dispatchEvent(new CustomEvent("discount:show"));
    }
    async _confirmRemove() {

      document.querySelector("apply-discount").dispatchEvent(new CustomEvent("discount:execute", {
        detail: {
          cart_id: this.cart_id, discount_code: this.discount_code, gifts: this.gifts, items: this.items
        }
      }));
      return;
    }
    _cancelRemove() {
      this._hidePopup();
      // call event stop loading btn
      document.querySelector("apply-discount").dispatchEvent(new CustomEvent("discount:apply:stoploading"));
    }
  }
  if (!window.customElements.get("popup-remove-gift")) {
    window.customElements.define("popup-remove-gift", PopupRemoveGift);
  }
  var PopupRemoveDiscount = class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("popup:show", this._showPopup.bind(this));
      this.addEventListener("popup:hide", this._hidePopup.bind(this));
      this.addEventListener("click", this._handleClick.bind(this));
      this.init();
    }
    init() {
      this.style.display = "none";
    }
    _showPopup(event) {
      const { cart_id, discount_code, items } = event.detail;
      if (!cart_id || !discount_code) return;
      this.cart_id = cart_id;
      this.discount_code = discount_code;
      // this.gifts = gifts;
      // this.items = items;
      const message = "Are you sure you want to remove the discount code : {{ discount_code }}?".replace("\{\{ discount_code \}\}", discount_code);
      this.updateMessage(message);
      this.style.display = "block";
    }
    updateMessage(message) {
      this.querySelector(".popup-message").innerHTML = message;
    }
    _handleClick(event) {

      if( event.target && event.target.classList.contains('confirm-remove-discount')) {
        this._confirmRemove();
        this._hidePopup();
        return;
      }
      this._cancelRemove();
      
    }
    _hidePopup() {
      this.style.display = "none";
      this.cart_id = null;
      this.discount_code = null;
      this.items = null;

      document.querySelector("apply-discount").dispatchEvent(new CustomEvent("discount:show"));
    }
    async _confirmRemove() {

      document.querySelector("apply-discount").dispatchEvent(new CustomEvent("discount:execute:cancel"));
      return;
    }
    _cancelRemove() {
      this._hidePopup();
      
      // call event stop loading btn
      document.querySelector("apply-discount").dispatchEvent(new CustomEvent("discount:apply:stoploading"));
    }
  }
  if (!window.customElements.get("popup-remove-discount")) {
    window.customElements.define("popup-remove-discount", PopupRemoveDiscount);
  }
})();